import React from 'react';
import {Button, Checkbox, Flex, Form, Input} from "antd";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import IntlMessage from "../../../../../../components/IntlMessage/IntlMessage";
import classes from "../../../Applications/application.module.css";

const Step8Authors = () => {
    const {t} = useTranslation();

    return (
        <Flex style={{width: "100%", position: "relative"}} vertical gap={"small"}>
            <IntlMessage id={"microQ.authors"}/>
            <Form.List name="opAuthors">
                {(fields, {add, remove}) => (
                    <Flex vertical gap={10}>
                        {fields.map(({key, name, ...restField}) => (
                            <Flex
                                key={key}
                                gap={"small"}
                                justify={"flex-start"}
                                align={"baseline"}
                                vertical
                                style={{
                                    padding: 8,
                                    border: '1px solid white',
                                    borderRadius: 8,
                                    backgroundColor: "white"
                                }}
                            >
                                <Form.Item
                                    {...restField}
                                    name={[name, 'id']}
                                    hidden
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'firstName']}
                                    className={classes.formInputBlock}
                                    rules={[{required: true, message: t('requiredField')}]}
                                >
                                    <Input placeholder={t('firstName')}/>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'middleName']}
                                    className={classes.formInputBlock}
                                    rules={[{required: false, message: t('requiredField')}]}
                                >
                                    <Input placeholder={t('middleName')}/>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'lastName']}
                                    className={classes.formInputBlock}
                                    rules={[{required: true, message: t('requiredField')}]}
                                >
                                    <Input placeholder={t('lastName')}/>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'firstNameEng']}
                                    className={classes.formInputBlock}
                                    rules={[{required: true, message: t('requiredField')}]}
                                >
                                    <Input placeholder={t('firstNameInEnglish')}/>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'lastNameEng']}
                                    className={classes.formInputBlock}
                                    rules={[{required: false, message: t('requiredField')}]}
                                >
                                    <Input placeholder={t('lastNameInEnglish')}/>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'positionRu']}
                                    className={classes.formInputBlock}
                                    rules={[{required: true, message: t('requiredField')}]}
                                    extra={t('example') + ': Главный менеджер / Генеральный директор'}
                                >
                                    <Input placeholder={t('position') + ' ' + t('inRu')}/>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'positionKz']}
                                    className={classes.formInputBlock}
                                    rules={[{required: true, message: t('requiredField')}]}
                                    extra={t('example') + ': Бас менеджер / Генеральный директор'}
                                >
                                    <Input placeholder={t('position') + " " + t('inKz')}/>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'positionEng']}
                                    className={classes.formInputBlock}
                                    rules={[{required: true, message: t('requiredField')}]}
                                    extra={t('example') + ': The general manager / CEO'}
                                >
                                    <Input placeholder={t('position') + " " + t('inEng')}/>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'workPlaceRu']}
                                    className={classes.formInputBlock}
                                    rules={[{required: true, message: t('requiredField')}]}
                                    extra={t('example') + ': ЦКС Astana IT University / «Корпоративный университет» — ...'}
                                >
                                    <Input placeholder={t('workPlace') + ' ' + t('inRu')}/>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'workPlaceKz']}
                                    className={classes.formInputBlock}
                                    rules={[{required: true, message: t('requiredField')}]}
                                    extra={t('example') + ': Astana IT University / «Корпоративный университет» — ...'}
                                >
                                    <Input placeholder={t('workPlace') + " " + t('inKz')}/>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'workPlaceEng']}
                                    className={classes.formInputBlock}
                                    rules={[{required: true, message: t('requiredField')}]}
                                    extra={t('example') + ': CCE Astana IT University / Corporate University ...'}
                                >
                                    <Input placeholder={t('workPlace') + " " + t('inEng')}/>
                                </Form.Item>
                                {/*<Form.Item*/}
                                {/*    {...restField}*/}
                                {/*    name={[name, 'isApprover']}*/}
                                {/*    className={classes.formInputBlock}*/}
                                {/*    label={t('microQ.isAuthorApprover')}*/}
                                {/*    valuePropName="checked"*/}
                                {/*    initialValue={false}*/}
                                {/*>*/}
                                {/*    <Checkbox/>*/}
                                {/*</Form.Item>*/}
                                <MinusCircleOutlined onClick={() => remove(name)}/>
                            </Flex>
                        ))}
                        <Form.Item>
                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                                <IntlMessage id={"certificate.addField"}/>
                            </Button>
                        </Form.Item>
                    </Flex>
                )}
            </Form.List>
        </Flex>
    );
};

export default Step8Authors;
